import gql from "graphql-tag";

export default gql`
  mutation DeleteProject($projectId: uuid!) {
    delete_projects(where: { id: { _eq: $projectId } }) {
      affected_rows
    }
  }
`;
